module.exports = __webpack_public_path__ + "BR.png?5730493f536fca3afdfb64833a4bd7ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/BR.png
// module id = 57
// module chunks = 0